/* eslint-disable prefer-promise-reject-errors */
import rout from "../../router";
import { logInReq } from "../../axiosfiles/axios-outh";
import decode from "jwt-decode";
// import router from "../../../../back-end/server/routers/login";
const TokenName = "TokenUser";
const TokenRoute = "AccessPath";
// const AdminToken = "xisabiye2"
export const state = {
  tokenID: null,
  rToken: null,
};
export const mutations = {
  OnLogIn(state, token) {
    state.tokenID = token;
    state.rToken = sessionStorage.getItem(TokenRoute);
  },
  OnAdminLogIn(state, { token, rToken }) {
    state.tokenID = token;
    state.rToken = rToken;
  },
  OnLogout(state) {
    state.tokenID = null;
    sessionStorage.removeItem(TokenRoute);
    sessionStorage.removeItem(TokenName);
    state.rToken = null;
    if (rout.currentRoute.name !== "fronPage") rout.push("/");
  },
};
export const actions = {
  AutoLogin({ commit }) {
    const token = sessionStorage.getItem(TokenName);
    commit("OnLogIn", token);
  },
  login({ commit }, LoginUser) {
    return new Promise((resolve, rejects) => {
      logInReq
        .post("/login", LoginUser)
        .then(user => {
          // console.log(user);
          commit("OnLogIn", user.data.token);
          // Resetting Product cart
          commit("RESET_CART");

          sessionStorage.setItem(TokenName, user.data.token);
          sessionStorage.setItem(TokenRoute, user.data.rToken);
          rout.push("/home");
          resolve("good");
        })
        .catch(err => {
          rejects(err);
        });
    });
  },
  Adminlogin({ commit }, { token, rToken }) {
    // Resetting Product cart
    commit("RESET_CART");
    commit("RESET_PRODUCTS");
    commit("OnAdminLogIn", { token, rToken });
    sessionStorage.setItem(TokenName, token);
    sessionStorage.setItem(TokenRoute, rToken);
    // console.log(rToken);
    // console.log(token);
    if (rout.currentRoute.name !== "Home") rout.push("/home");
    // resolve("good");
  },
};
export const getters = {
  isAuthenticated(state) {
    const token = sessionStorage.getItem(TokenName);
    state.tokenID = token;
    return state.tokenID !== null;
  },
  showToken(state) {
    let tID = state.tokenID;
    const token = sessionStorage.getItem(TokenName);
    if (tID === token && token != null) return tID;
    else return null;
  },
  showRtoken(state) {
    let tID = state.rToken;
    const token = sessionStorage.getItem(TokenRoute);
    return tID || token;
  },
  GetterRouter({ rToken }) {
    try {
      if (rToken) {
        let { ogol } = decode(rToken) || [];
        // console.log(ogol);
        return ogol;
      }
      return [];
    } catch (error) {
      console.log(error);
      return [];
    }
  },
  UsersToken({ tokenID }) {
    try {
      if (tokenID) return decode(tokenID);
      else return {};
    } catch (error) {
      console.log(error);
      return {};
    }
  },
};
